import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Media',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
